import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';

export const templateMaintenanceWindowsDeleteDialog = document.createElement('template');

templateMaintenanceWindowsDeleteDialog.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div>
    <gz-text fontSize="14" id="warning-text"></gz-text>
    <br>
    <div class="impact-info-wrapper">
        <div class="loading-container">
          <gz-progress-spinner size="large"></gz-progress-spinner>
        </div>
        <div class="impact-info">
          <gz-text fontSize="14" id="impact-summary-text"></gz-text>
          <div id="impact-details-text"></div>
        </div>
    </div>
  </div>
`;
